import { StyledText } from 'typescript/components/option_rows/option_row';
import { PickupOption } from 'typescript/types/api/pickup_options';
import {
  distanceToStore,
  durationStr,
  fullLocationName,
  openUntilStr,
  pickupLocationAddress,
  readyDateStr,
} from 'typescript/utilities/bopis_strings';

const buildSubtext = (pickupOption: PickupOption) => {
  const {
    availability_date,
    days_until_available,
    hours_on_availability_date,
    open_now,
    pickup_ready_in_minutes,
    timezone,
  } = pickupOption;

  const subtextArr: (string | StyledText)[] = [
    pickupLocationAddress(pickupOption),
  ];

  // e.g. 'Open until 10 pm' (if open) OR 'Ready today' (if not)
  if (open_now && days_until_available === 0) {
    subtextArr.push(openUntilStr(hours_on_availability_date?.close));
  } else {
    subtextArr.push(
      readyDateStr(days_until_available, availability_date, timezone),
    );
  }

  if (pickup_ready_in_minutes && open_now) {
    subtextArr.push({
      text: durationStr(pickup_ready_in_minutes),
      style: 'success',
    });
  }

  return subtextArr;
};

export const buildOptionFromPickupOption = ({
  pickupOption,
  chosenPickupLocationId,
}: {
  pickupOption: PickupOption;
  chosenPickupLocationId?: string;
}) => {
  const locationId = pickupOption.location_id.toString();

  return {
    id: locationId,
    title: fullLocationName(pickupOption),
    subtext: buildSubtext(pickupOption),
    sideLabel: distanceToStore(pickupOption.distance_in_miles),
    value: locationId,
    selected: locationId === chosenPickupLocationId,
  };
};
